// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cdMEEY {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  position: relative;
}

.grOgAr {
  display: flex;
  gap: 8px;
  align-items: center;
  flex-wrap: nowrap;
  position: relative;
}

.f8Ktoa {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.zqghg1 {
  padding: 6px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  background-color: white;
  font-size: 12px;
  color: #666;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
}

.zqghg1:hover {
  border-color: #ff5c00;
}

.zqghg1.YpDvzq {
  background-color: #ff5c00;
  color: white;
  border-color: #ff5c00;
}

.JF1xO6 {
  width: 12px;
  height: 12px;
  flex-shrink: 0;
}

.Uu0yv_ {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 8px;
  z-index: 1001;
}

.Uu0yv_ [data-testid='select-date-period-fields'] {
  display: none !important;
}

.RrbgPT {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: none;
  background-color: #ff5c00;
  color: white;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: background-color 0.2s;
}

.RrbgPT:hover {
  background-color: #e54f00;
}

.eoRVg5 {
  padding: 6px 10px;
  border: 1px solid #e0e0e0;
  border-radius: 20px;
  background-color: white;
  font-size: 12px;
  color: #666;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
}

.eoRVg5:hover {
  border-color: #ff5c00;
}

.eoRVg5.YpDvzq {
  background-color: #ff5c00;
  color: white;
  border-color: #ff5c00;
}

.Hu_1Z4 {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.Q3r3_d {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 16px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background-color: white;
  gap: 16px;
}

.YavXeL {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-width: 0;
}

.QEpUQD {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.I8bjNh {
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  flex-shrink: 0;
}

.I8bjNh.lNZg4K {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.I8bjNh.jC7KYs {
  background-color: #fff3e0;
  color: #ef6c00;
}

.I8bjNh.Ce8aJR {
  background-color: #ffebee;
  color: #c62828;
}

.qq2QrX {
  font-size: 12px;
  color: #999;
  white-space: nowrap;
}

.fg5b_Q {
  font-size: 14px;
  color: #333;
  word-break: break-word;
}

.FIDLM1 {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.BLg5pf {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  white-space: nowrap;
}

.buheA6 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  text-align: center;
}

.vQl78O {
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
  opacity: 0.3;
}

.GFqUP1 {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.lOX5KR {
  font-size: 14px;
  color: #666;
  margin: 0;
  max-width: 400px;
}

.bdBwVg {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 48px;
}

.P76PqN {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 64px 24px;
  text-align: center;
}

.PwtVRd {
  width: 80px;
  height: 80px;
  margin-bottom: 24px;
  color: #c62828;
}

.DPgXOQ {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin: 0 0 8px 0;
}

.DmvSrv {
  font-size: 14px;
  color: #666;
  margin: 0 0 24px 0;
  max-width: 400px;
}

.Uk7a4W {
  padding: 12px 24px;
  border: none;
  background-color: #ff5c00;
  color: white;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.Uk7a4W:hover {
  background-color: #e54f00;
}
`, "",{"version":3,"sources":["webpack://./../../packages/pagamentos/src/components/LimitsHistory/LimitsHistory.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n  width: 100%;\n  position: relative;\n}\n\n.filters {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  flex-wrap: nowrap;\n  position: relative;\n}\n\n.periodFilterWrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.periodButton {\n  padding: 6px 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 20px;\n  background-color: white;\n  font-size: 12px;\n  color: #666;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.periodButton:hover {\n  border-color: #ff5c00;\n}\n\n.periodButton.active {\n  background-color: #ff5c00;\n  color: white;\n  border-color: #ff5c00;\n}\n\n.calendarIcon {\n  width: 12px;\n  height: 12px;\n  flex-shrink: 0;\n}\n\n.periodCalendarWrapper {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 8px;\n  z-index: 1001;\n}\n\n.periodCalendarWrapper :global([data-testid='select-date-period-fields']) {\n  display: none !important;\n}\n\n.clearFilter {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  border: none;\n  background-color: #ff5c00;\n  color: white;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  transition: background-color 0.2s;\n}\n\n.clearFilter:hover {\n  background-color: #e54f00;\n}\n\n.filterChip {\n  padding: 6px 10px;\n  border: 1px solid #e0e0e0;\n  border-radius: 20px;\n  background-color: white;\n  font-size: 12px;\n  color: #666;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.filterChip:hover {\n  border-color: #ff5c00;\n}\n\n.filterChip.active {\n  background-color: #ff5c00;\n  color: white;\n  border-color: #ff5c00;\n}\n\n.list {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.listItem {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  padding: 16px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background-color: white;\n  gap: 16px;\n}\n\n.listItemLeft {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-width: 0;\n}\n\n.listItemTop {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.badge {\n  padding: 4px 12px;\n  border-radius: 12px;\n  font-size: 12px;\n  font-weight: 600;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.badge.approved {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.badge.pending {\n  background-color: #fff3e0;\n  color: #ef6c00;\n}\n\n.badge.rejected {\n  background-color: #ffebee;\n  color: #c62828;\n}\n\n.listItemDate {\n  font-size: 12px;\n  color: #999;\n  white-space: nowrap;\n}\n\n.listItemDescription {\n  font-size: 14px;\n  color: #333;\n  word-break: break-word;\n}\n\n.listItemRight {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.listItemValue {\n  font-size: 16px;\n  font-weight: 600;\n  color: #333;\n  white-space: nowrap;\n}\n\n.empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  text-align: center;\n}\n\n.emptyIcon {\n  width: 80px;\n  height: 80px;\n  margin-bottom: 24px;\n  opacity: 0.3;\n}\n\n.emptyTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 8px 0;\n}\n\n.emptyDescription {\n  font-size: 14px;\n  color: #666;\n  margin: 0;\n  max-width: 400px;\n}\n\n.loading {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding: 48px;\n}\n\n.error {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 64px 24px;\n  text-align: center;\n}\n\n.errorIcon {\n  width: 80px;\n  height: 80px;\n  margin-bottom: 24px;\n  color: #c62828;\n}\n\n.errorTitle {\n  font-size: 18px;\n  font-weight: 600;\n  color: #333;\n  margin: 0 0 8px 0;\n}\n\n.errorDescription {\n  font-size: 14px;\n  color: #666;\n  margin: 0 0 24px 0;\n  max-width: 400px;\n}\n\n.retryButton {\n  padding: 12px 24px;\n  border: none;\n  background-color: #ff5c00;\n  color: white;\n  font-size: 14px;\n  font-weight: 600;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.retryButton:hover {\n  background-color: #e54f00;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `cdMEEY`,
	"filters": `grOgAr`,
	"periodFilterWrapper": `f8Ktoa`,
	"periodButton": `zqghg1`,
	"active": `YpDvzq`,
	"calendarIcon": `JF1xO6`,
	"periodCalendarWrapper": `Uu0yv_`,
	"clearFilter": `RrbgPT`,
	"filterChip": `eoRVg5`,
	"list": `Hu_1Z4`,
	"listItem": `Q3r3_d`,
	"listItemLeft": `YavXeL`,
	"listItemTop": `QEpUQD`,
	"badge": `I8bjNh`,
	"approved": `lNZg4K`,
	"pending": `jC7KYs`,
	"rejected": `Ce8aJR`,
	"listItemDate": `qq2QrX`,
	"listItemDescription": `fg5b_Q`,
	"listItemRight": `FIDLM1`,
	"listItemValue": `BLg5pf`,
	"empty": `buheA6`,
	"emptyIcon": `vQl78O`,
	"emptyTitle": `GFqUP1`,
	"emptyDescription": `lOX5KR`,
	"loading": `bdBwVg`,
	"error": `P76PqN`,
	"errorIcon": `PwtVRd`,
	"errorTitle": `DPgXOQ`,
	"errorDescription": `DmvSrv`,
	"retryButton": `Uk7a4W`
};
module.exports = ___CSS_LOADER_EXPORT___;
